<template>
  <h1>OrdersPage</h1>
</template>

<script>
export default {
  name: "OrdersPage",
  props: {

  }
}
</script>

<style scoped>

</style>